const properCase = (str: string) =>
  str
    .replace(/(\w)(\w*)/g, (_g0, g1: string, g2: string) => `${g1.toUpperCase()}${g2}`)
    .replace(/\s/g, '');

export default properCase;